/* RESPONSIBLE TEAM: team-proactive-support */
import SalesRoute from './base/sales-route';

export default SalesRoute.extend();
